export enum PickerType {
	Color = 'color',
	Rim = 'rim',
	Interior = 'interior'
}
